module.exports = __webpack_public_path__ + "static/media/freechoicegroup.40d701c6.jpg";